import { combineReducers } from 'redux';
import notificationsPreferencesReducer from './preferences';
import notificationsProxiesReducer from './proxies';
import notificationsHipaaReducer from './hipaa';
import notificationsPushTokenReducer from './pushToken';

export default combineReducers({
  preferences: notificationsPreferencesReducer,
  proxies: notificationsProxiesReducer,
  hipaa: notificationsHipaaReducer,
  pushToken: notificationsPushTokenReducer
});
